var map = {
	"./news_carousel.js": "./assets/js/slick-runners/news_carousel.js",
	"./slides.js": "./assets/js/slick-runners/slides.js",
	"./testimonial_carousel.js": "./assets/js/slick-runners/testimonial_carousel.js",
	"./video_blocks.js": "./assets/js/slick-runners/video_blocks.js",
	"./videos.js": "./assets/js/slick-runners/videos.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./assets/js/slick-runners sync \\.(js)$";